import React, { useState } from "react";
import chicken from "../assets/chicken.jpg";
import meat from "../assets/meat.jpg";
import vegetables from "../assets/vegetables.jpg";
import rice from "../assets/rice.jpg";
import soup from "../assets/soup.jpg";
import sweets from "../assets/sweets.jpg";

function Categories() {
  const [openTitle, setOpenTitle] = useState(null);
  const [activeFilter, setActiveFilter] = useState("الكل");

  const filters = ["الكل", "نباتي", "سريعة", "رئيسية", "صحي"];

  const categories = [
    {
      image: chicken,
      title: "طبخات بالدجاج",
      description: "وصفات دجاج شهية ومتنوعة",
      dishes: ["دجاج بالبطاطا", "شيش برك بالدجاج", "دجاج بالكريمة", "كبسة دجاج"],
      tags: ["رئيسية", "سريعة"],
    },
    {
      image: meat,
      title: "طبخات باللحم",
      description: "أطباق لحم غنية بالنكهة",
      dishes: ["كباب بالفرن", "داوود باشا", "كفتة بالبطاطا", "يخنة لحم"],
      tags: ["رئيسية"],
    },
    {
      image: vegetables,
      title: "طبخات بالخضار",
      description: "وصفات خفيفة بخضار موسمية",
      dishes: ["محشي كوسا", "مسقعة", "فاصوليا", "خضار بالفرن"],
      tags: ["نباتي", "صحي"],
    },
    {
      image: rice,
      title: "أرز ومعكرونة",
      description: "أطباق مشبعة وسهلة التحضير",
      dishes: ["كسة", "رز بالخضار", "معكرونة بالشاميل", "معكرونة بالصلصة"],
      tags: ["رئيسية"],
    },
    {
      image: soup,
      title: "شوربات",
      description: "شوربات دافئة لكل الأوقات",
      dishes: ["شوربة عدس", "شوربة خضار", "شوربة دجاج", "شوربة فطر"],
      tags: ["صحي", "سريعة"],
    },
    {
      image: sweets,
      title: "حلويات",
      description: "حلويات بيتية بوصفات مجربة",
      dishes: ["كنافة", "معمول", "هريسة", "ليالي لبنان"],
      tags: ["سريعة"],
    },
  ];

  const visibleCategories =
    activeFilter === "الكل"
      ? categories
      : categories.filter((cat) => cat.tags.includes(activeFilter));

  const toggleCard = (title) => {
    setOpenTitle((prev) => (prev === title ? null : title));
  };

  const selectFilter = (filter) => {
    setActiveFilter(filter);
    setOpenTitle(null);
  };

  return (
    <section
      dir="rtl"
      id="categories"
      className="
        w-full
        mx-auto
        flex
        flex-col
        gap-[10px]
        box-border
        bg-[#F8E6E3]
        font-['Cairo']
        px-36
        py-10
        max-[900px]:px-10
        max-[600px]:px-5
        max-[600px]:py-[30px]
      "
    >
      <div className="w-full max-w-[1440px] mx-auto box-border">
        <div className="text-center mb-8">
          <h2
            className="
              m-0
              mb-[10px]
              font-['Cairo']
              text-[26px]
              font-extrabold
              text-[#1a1a1a]
              leading-[1.4]
              tracking-[-0.36px]
              text-center
              max-w-[917px]
              w-full
              mx-auto
              whitespace-normal
              max-[600px]:text-[18px]
            "
          >
            اختاري ما تفضلينه واستمتعي بتجربة طهي سهلة ومميزة.
          </h2>

          <p className="m-0 mb-[26px] text-[#777] text-[13.5px] leading-[1.6] font-['Cairo']">
            تصفحي الأقسام واختاري طبختك، ونحن نجهز لك محتواها بالمقادير والخطوات
          </p>

          <div
            className="
              flex
              justify-center
              items-center
              gap-3
              mb-8
              flex-nowrap
              overflow-x-auto
              pb-1
              [scrollbar-width:none]
              [-ms-overflow-style:none]
              [&::-webkit-scrollbar]:hidden
              max-[600px]:gap-2
              max-[600px]:justify-start
            "
          >
            {filters.map((filter) => {
              const isActive = activeFilter === filter;

              return (
                <button
                  key={filter}
                  type="button"
                  onClick={() => selectFilter(filter)}
                  className={`
                    font-['Cairo']
                    text-[13px]
                    font-bold
                    leading-none
                    cursor-pointer
                    px-[16px]
                    py-2
                    rounded-full
                    transition-all
                    duration-200
                    whitespace-nowrap
                    shrink-0
                    max-[600px]:text-[11px]
                    max-[600px]:px-[11px]
                    max-[600px]:py-[6px]
                    ${
                      isActive
                        ? "border border-[#D40C1A] bg-[#D40C1A] text-[#FEFBF8] shadow-[0_2px_7px_rgba(0,0,0,0.08)]"
                        : "border border-[#eeeeee] bg-white text-[#1a1a1a] shadow-[0_2px_7px_rgba(0,0,0,0.08)] hover:border-[#dddddd] hover:shadow-[0_3px_10px_rgba(0,0,0,0.13)] hover:-translate-y-px"
                    }
                  `}
                >
                  {filter}
                </button>
              );
            })}
          </div>
        </div>

        <div
          className="
            w-full
            grid
            grid-cols-3
            gap-x-7
            gap-y-8
            items-start
            justify-items-center
            max-[900px]:grid-cols-2
            max-[900px]:gap-x-5
            max-[600px]:grid-cols-1
          "
        >
          {visibleCategories.map((cat) => {
            const isOpen = openTitle === cat.title;

            return (
              <div
                key={cat.title}
                onClick={() => toggleCard(cat.title)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && toggleCard(cat.title)}
                aria-expanded={isOpen}
                className={`
                  group
                  w-full
                  max-w-[358.33px]
                  overflow-hidden
                  flex
                  flex-col
                  bg-white
                  rounded-[24px]
                  border
                  border-[#f0ddd8]
                  box-border
                  cursor-pointer
                  transition-all
                  duration-300
                  ease-out
                  hover:-translate-y-1.5
                  hover:shadow-[0_18px_40px_rgba(120,32,24,0.12)]
                  hover:border-[#efc4be]
                  max-[600px]:max-w-full
                  ${
                    isOpen
                      ? "-translate-y-1.5 shadow-[0_18px_40px_rgba(120,32,24,0.12)] border-[#efc4be]"
                      : "shadow-[0_8px_22px_rgba(80,24,16,0.06)]"
                  }
                `}
              >
                <div className="relative w-full h-[240px] overflow-hidden shrink-0 max-[600px]:h-[210px]">
                  <img
                    src={cat.image}
                    alt={cat.title}
                    className={`
                      w-full
                      h-full
                      object-cover
                      object-center
                      block
                      transition-transform
                      duration-500
                      ease-out
                      group-hover:scale-105
                      ${isOpen ? "scale-105" : "scale-100"}
                    `}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 px-5 pb-4 pt-10 flex items-center justify-start gap-2.5">
                    <h3 className="m-0 min-w-0 text-white font-['Cairo'] text-[18px] font-extrabold leading-[1.35] drop-shadow-[0_2px_8px_rgba(0,0,0,0.35)] max-[600px]:text-[16px]">
                      {cat.title}
                    </h3>
                    <span
                      className={`
                        w-8
                        h-8
                        shrink-0
                        rounded-full
                        bg-white/95
                        text-[#D40C1A]
                        flex
                        items-center
                        justify-center
                        shadow-[0_2px_8px_rgba(0,0,0,0.12)]
                        transition-transform
                        duration-300
                        ${isOpen ? "rotate-180" : ""}
                      `}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path
                          d="M6 9L12 15L18 9"
                          stroke="currentColor"
                          strokeWidth="2.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>

                <div className="px-5 pt-4 pb-5 text-right bg-white flex-1 box-border min-h-[76px]">
                  {isOpen ? (
                    <div
                      className="flex flex-wrap gap-2 justify-start animate-[fadeIn_0.2s_ease]"
                      key={`dishes-${cat.title}`}
                    >
                      {cat.dishes.map((dish) => (
                        <span
                          key={dish}
                          className="inline-flex items-center rounded-full bg-[#F8E6E3] text-[#5c2a26] font-['Cairo'] text-[12px] font-semibold px-3 py-[6px]"
                        >
                          {dish}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <p
                      className="m-0 text-[#6b5a56] font-['Cairo'] text-[13px] font-medium leading-[1.7] animate-[fadeIn_0.2s_ease]"
                      key={`desc-${cat.title}`}
                    >
                      {cat.description}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Categories;
